function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import levenshtein from 'fast-levenshtein';
import { convertUserDetailsToJson } from 'shared/view/user-conversion-service';
import * as c from './constants';
export var loadAccount = function loadAccount(apiRoot, foundUsOptions, userIdentity) {
  return function (dispatch, getState, _ref) {
    var application = _ref.application;
    var route = userIdentity ? "".concat(apiRoot, "/").concat(userIdentity, "/load") : "".concat(apiRoot, "/load");
    return dispatch(application.get(route)).then(function (json) {
      dispatch(_objectSpread(_objectSpread({
        type: c.ACCOUNT_LOADED
      }, json), {}, {
        navigation: {
          changePasswordEnabled: json.user && json.user.changePasswordEnabled && !json.user.impersonatorIdentity,
          editSavedAddressesEnabled: json.user && json.user.addresses.length > 0
        }
      }));
      return json;
    });
  };
};
export var findInstitutionsBy = function findInstitutionsBy(field, fieldValue) {
  return function (dispatch, getState, _ref2) {
    var application = _ref2.application;
    return dispatch(application.get("/api/account/search-institutions", _defineProperty({}, field, fieldValue.toLowerCase()))).then(function (institutions) {
      var options = institutions.map(function (institution) {
        return {
          institution: institution,
          identity: institution.identity,
          label: institution.name,
          value: institution.identity,
          match: levenshtein.get(institution.name.toLowerCase(), fieldValue.toLowerCase())
        };
      }).sort(function (a, b) {
        return a.match - b.match;
      }).slice(0, 10);
      return options;
    });
  };
};
export var requestUpdate = function requestUpdate() {
  return {
    type: c.UPDATE_REQUESTED
  };
};
var completeUpdateWithMessage = function completeUpdateWithMessage(message) {
  return function (dispatch, getState, _ref3) {
    var application = _ref3.application;
    dispatch(application.addMessage(message));
    dispatch({
      type: c.UPDATE_REQUEST_COMPLETED
    });
  };
};
export var completeUpdate = function completeUpdate(success) {
  var messageString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return function (dispatch) {
    var defaultMessageString = success ? 'Account settings modified successfully.' : 'We apologize for the inconvenience, but your account could not be updated.';
    dispatch(completeUpdateWithMessage({
      type: success ? 'success' : 'error',
      message: messageString || defaultMessageString
    }));
  };
};
export var updateInstitutionInformation = function updateInstitutionInformation(apiRoot, userIdentity, institutionInformationUpdateRequest) {
  return function (dispatch, getState, _ref4) {
    var application = _ref4.application;
    dispatch(requestUpdate());
    return dispatch(application.put("".concat(apiRoot, "/").concat(userIdentity, "/update-institution-information"), institutionInformationUpdateRequest)).then(function (json) {
      var _json$error$error, _json$error;
      var error = (_json$error$error = (_json$error = json.error) === null || _json$error === void 0 ? void 0 : _json$error.error) !== null && _json$error$error !== void 0 ? _json$error$error : '';
      dispatch(completeUpdate(!json.error, error));
      return {
        error: error,
        user: convertUserDetailsToJson(json.userDetails)
      };
    }).catch(function () {
      return dispatch(completeUpdate(false));
    });
  };
};
export var updatePassword = function updatePassword(apiRoot, userIdentity, changePasswordRequest) {
  return function (dispatch, getState, _ref5) {
    var application = _ref5.application;
    dispatch(requestUpdate());
    return dispatch(application.post("".concat(apiRoot, "/").concat(userIdentity, "/update-password"), changePasswordRequest)).then(function (json) {
      var error = json.error;
      var message = error ? {
        message: error.error,
        type: 'error'
      } : {
        message: 'Your password has been updated.',
        type: 'success'
      };
      dispatch(completeUpdateWithMessage(message));
      return json;
    });
  };
};
export var updateAccount = function updateAccount(apiRoot, userIdentity, userUpdateRequest) {
  return function (dispatch, getState, _ref6) {
    var application = _ref6.application;
    dispatch(requestUpdate());
    var request = userIdentity ? application.put("".concat(apiRoot, "/").concat(userIdentity, "/update-details"), userUpdateRequest) : application.post("".concat(apiRoot, "/create"), userUpdateRequest);
    return dispatch(request).then(function (json) {
      var _json$error$error2, _json$error2;
      var error = (_json$error$error2 = (_json$error2 = json.error) === null || _json$error2 === void 0 ? void 0 : _json$error2.error) !== null && _json$error$error2 !== void 0 ? _json$error$error2 : '';
      dispatch(completeUpdate(!json.error, error));
      return {
        error: error,
        user: convertUserDetailsToJson(json.userDetails)
      };
    });
  };
};
export var updatePhoneVerificationDetails = function updatePhoneVerificationDetails(apiRoot, userIdentity, userUpdateRequest) {
  return function (dispatch, getState, _ref7) {
    var application = _ref7.application;
    return dispatch(application.put("".concat(apiRoot, "/").concat(userIdentity, "/update-phone-verification-details"), userUpdateRequest)).then(function (json) {
      var _json$error$error3, _json$error3;
      return {
        error: (_json$error$error3 = (_json$error3 = json.error) === null || _json$error3 === void 0 ? void 0 : _json$error3.error) !== null && _json$error$error3 !== void 0 ? _json$error$error3 : '',
        user: convertUserDetailsToJson(json.userDetails)
      };
    });
  };
};
export var findPreferredGroups = function findPreferredGroups(query) {
  return function (dispatch, getState, _ref8) {
    var application = _ref8.application;
    return new Promise(function (resolve) {
      dispatch(application.get('/api/preferred-groups/search', query)).then(function (json) {
        var preferredGroups = json.results;
        var options = preferredGroups.map(function (details) {
          return _objectSpread(_objectSpread({}, details), {}, {
            value: details.code
          });
        });
        resolve(options);
      });
    });
  };
};
export var requestCuriePlanForUser = function requestCuriePlanForUser(userIdentity) {
  return function (dispatch, getState, _ref9) {
    var application = _ref9.application;
    dispatch({
      type: c.RUBRIQ_PLAN_REQUESTED
    });
    return dispatch(application.get("/api/admin/curie/".concat(userIdentity, "/load"))).then(function (json) {
      dispatch({
        type: c.RUBRIQ_PLAN_LOADED,
        json: json
      });
      return json;
    });
  };
};
export var getWeChatBindingQrCode = function getWeChatBindingQrCode() {
  return function (dispatch, getState, _ref10) {
    var application = _ref10.application;
    dispatch({
      type: c.QR_CODE_REQUESTED
    });
    return dispatch(application.post("/api/auth/wechat-binding")).then(function (_ref11) {
      var error = _ref11.error,
        ticket = _ref11.ticket,
        url = _ref11.url;
      var result = {
        error: error,
        qrCodeUrl: null
      };
      dispatch({
        type: c.QR_CODE_RETRIEVED
      });
      if (error) {
        dispatch(application.addMessage({
          type: 'error',
          message: error
        }));
      }
      if (url && ticket) {
        result.qrCodeUrl = "https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=".concat(ticket);
      }
      return result;
    });
  };
};